module.exports = __webpack_public_path__ + "img/fullscreen.fc865f54.svg";